// extracted by mini-css-extract-plugin
export default {"card":"RY-z","carouselContainer":"SY-z","carouselContent":"TY-z"};